var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCajaIcono(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 13,
    width: 21,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04297 13.1602H23.6504V29.7501H3.04297V13.1602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4729 13.1602H4.22054C3.57023 13.1602 3.04297 13.693 3.04297 14.3502V29.4527C3.04297 29.617 3.17456 29.7502 3.33736 29.7502H23.3561C23.5189 29.7502 23.6504 29.617 23.6504 29.4527V14.3502C23.6504 13.693 23.1232 13.1602 22.4729 13.1602ZM4.51493 28.2627H22.1785V14.6477H4.51493V28.2627Z",
    fill: "#1A3992"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4609 6.54492H6.23231C6.12191 6.54492 6.02064 6.62644 5.96824 6.75763L3.07966 13.9774C2.97132 14.2484 3.11587 14.5774 3.34343 14.5774H23.3498C23.5773 14.5774 23.7219 14.2484 23.6135 13.9774L20.7247 6.75763C20.6726 6.62644 20.5713 6.54492 20.4609 6.54492ZM19.8456 7.73492L22.1074 13.3874H4.58577L6.84759 7.73492H19.8456Z",
    fill: "#1A3992"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9922 18.7424V13.0741L12.0714 7.13989H14.6232L15.7025 13.0741V18.7424H10.9922Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1165 6.54492H11.5838L10.4062 13.02V19.3374H16.2941V13.02L15.1165 6.54492ZM14.1356 7.73492L15.1165 13.1283V18.1474H11.5838V13.1283L12.5647 7.73492H14.1356Z",
    fill: "#1A3992"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 31,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05078 1.8418H31.5489V20.0946H1.05078V1.8418Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8013 20.0946C26.5567 20.0946 26.3164 19.9759 26.1689 19.7555C25.9331 19.4026 26.025 18.9237 26.3738 18.6857C28.6595 17.1253 30.024 14.532 30.024 11.7485C30.024 7.13581 26.3105 3.38314 21.746 3.38314H1.81326C1.39228 3.38314 1.05078 3.03804 1.05078 2.61232C1.05078 2.18719 1.39228 1.8418 1.81326 1.8418H21.746C27.1513 1.8418 31.549 6.28585 31.549 11.7485C31.549 15.0445 29.9336 18.1153 27.2273 19.9625C27.0966 20.0518 26.9479 20.0946 26.8013 20.0946Z",
    fill: "#1A3992"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 0H4.23406V5.22499H0.25V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1833)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10551 4.47321L2.57143 2.92383C2.40127 2.75187 2.40127 2.47282 2.57143 2.30116L4.10551 0.751782C4.38018 0.474512 4.18559 0 3.79758 0H2.83521C2.71981 0 2.60882 0.04641 2.52727 0.128817L0.377619 2.30116C0.20746 2.47312 0.20746 2.75187 0.377619 2.92383L2.52727 5.09588C2.60882 5.17858 2.71981 5.22499 2.83521 5.22499H3.79758C4.18559 5.22499 4.38018 4.75048 4.10551 4.47321Z",
    fill: "#1A3992"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCajaIcono);
export default __webpack_public_path__ + "static/media/CajaIcono.a628d39b78db091751b6fc25bf3087bb.svg";
export { ForwardRef as ReactComponent };